var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSubscriptionIcon = function SvgSubscriptionIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.3551 21.8674L40.0028 40.0007L8.65039 21.8674C9.29412 20.7532 10.2121 19.8221 11.3171 19.1626L36.1932 4.80071C38.5579 3.46723 41.4476 3.46723 43.8123 4.80071L68.6885 19.1626C69.7934 19.8221 70.7114 20.7532 71.3551 21.8674Z",
    fill: "#E9FFF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9981 40.0003V76.1908C38.797 76.1892 37.6119 75.9157 36.5315 75.3908L11.4267 60.8765C9.07349 59.5152 7.62233 57.0046 7.61719 54.2861V25.7146C7.62351 24.365 7.9778 23.0398 8.64576 21.867L39.9981 40.0003Z",
    fill: "#5CD6AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.381 25.7146V54.2861C72.3758 57.0046 70.9247 59.5152 68.5714 60.8765L43.3524 75.4289C42.3036 75.9235 41.1595 76.1836 40 76.1908V40.0003L71.3524 21.867C72.0203 23.0398 72.3746 24.365 72.381 25.7146Z",
    fill: "#ADEBD6"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSubscriptionIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/subscriptionIcon.c3058115.svg";
export { ForwardRef as ReactComponent };